import axios from 'axios';
import { envConfig } from '../../../env';


// const source = 'https://servertest.cottongame.com/source'
const source = envConfig.formalServer + '/source';
// const sourceFormal = 'https://server.cottongame.com/source'
const sourceFormal = envConfig.formalServer + "/source"

// const cottonFormal = 'https://server.cottongame.com/cotton'
const cottonFormal = envConfig.formalServer + "/cotton"


//--- DeviceInfo.vue
export const findSourceServiceLog = params => axios.get(source + '/findServiceLog?dateTime=' + params)             // 获取 serverstore 日志
export const findSourceServiceLogFormal = params => axios.get(sourceFormal + '/findServiceLog?dateTime=' + params) // 获取 serverstore 日志 - 正式服

export const findCottonServiceLogFormal = params => axios.get(cottonFormal + '/findServiceLog?dateTime=' + params) // 获取 cotton 日志 - 正式服

export const getAllMemberName = params => axios.post(cottonFormal + '/getAllMemberName', params)                   // 获取内部人员数据
